import React, { useState, useContext } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { SEARCH, SearchContext } from '../search/SearchContext'
import HotelBookingForm from './HotelBookingForm'
import HotelQualifiedQuestionsForm from './HotelQualifiedQuestionsForm'
import BookingConfirmation from '../bookings/BookingConfirmation'
import ResortFeeDialog from './ResortFeeDialog'
import {
  isTourOperator,
  isPrePayUser,
  isBookingAgentAndisBookingAnUpgrade,
  isBookingAgentAndisBookingAfresh,
  isNotPriceApplicableUser
} from '../helpers/userHelper'
import Loading from '../common/Loading'
import { getDepartureDateMoment } from '../helpers/hotelHelper'

const HotelBooking = ({setRoomsTitle}) => {
  const { state, dispatch } = useContext(SearchContext)
  const {
    booking,
    room,
    user,
    nights,
    arrival,
    adults,
    searchedArrival,
    searchedNights,
    searchedAdults
  } = state
  const [success, setSuccess] = useState(false)
  const [submitting, setFormSubmitting] = useState(false)

  const _closeHandler = (e) => {
    e.preventDefault()
    dispatch({ type: SEARCH.BOOKING.SET, payload: null })
  }
  const _setBooking = (payload) =>
    dispatch({ type: SEARCH.BOOKING.SET, payload })

  const [tourOperatorNotes, setTourOperatorNotes] = useState("")

  const _displayBookingForm = () => {
    let newBooking = { ...booking }
    newBooking.step = 'book_room'
    _setBooking(newBooking)
  }

  const outputDatesAndTotal = () => {
    if (isNotPriceApplicableUser(state.user)) {
      return null
    }
    return (
      <React.Fragment>
        <div className="dates">
          <p className="thin-p space-between single-line room-total">
            <span>Total for {parseInt(searchedNights)} night(s) = ${calcRoomTotal()}</span>
          </p>
          {isBookingAgentAndisBookingAnUpgrade(state) && (
            <p className="thin-p space-between single-line room-total">
              <span>Upgrade Total for {parseInt(searchedNights)} night(s) = ${Math.ceil(parseFloat(room.rates[0].surcharge))}</span>
            </p>
          )}
        </div>
        { _checkAndDisplayResortFee() }
      </React.Fragment>
    )
  }

  const calcRoomTotal = () => {
    let total = 0
    if ((isTourOperator(user) || isBookingAgentAndisBookingAfresh(state)) && !isPrePayUser(user) && room.rates[0].surcharge) {
      total = Math.ceil(parseFloat(room.rates[0].base)) + parseFloat(room.rates[0].surcharge)
    } else {
      total = Math.ceil(room.rates[0].net)
    }
    return total
  }

  const _displaySelectedRoom = () => {
    let pricing
    if ((isTourOperator(user) || isBookingAgentAndisBookingAfresh(state)) && !isPrePayUser(user) && room.rates[0].surcharge) {
      pricing = (
        <div className="rooms">
          <p className="room single">
            <span className="name">{room.name}</span>
            <span className="price">${Math.ceil(parseFloat(room.rates[0].base))}</span>
          </p>
          <p className="room single">
            <span className="name">Upgrade</span>
            <span className="price">${room.rates[0].surcharge}</span>
          </p>
      </div>
      )
    } else {
      pricing = (
        <div className="rooms">
          <p className="room single">
            <span className="name">{room.name}</span>
          </p>
        </div>
      )
    }

    return (
      <React.Fragment>
        { setRoomsTitle("Reservation Summary", true, false, false) }
        <h4>Room Type Selected</h4>
        { pricing }
        { outputDatesAndTotal() }
      </React.Fragment>
    )
  }

  const _checkAndDisplayResortFee = () => {
    // Las Vegas, display resort fee disclosure
    if(booking.hotel.destination_code === "LVS") {
      return <ResortFeeDialog />
    }
  }

  const _renderInfo = () => {
    return <div className="hotel-booking">
      <h2>{booking.hotel.name}</h2>
      <hr />
      { room && _displaySelectedRoom() }

      {
        (booking.step === 'book_room_and_tour') &&
        <HotelQualifiedQuestionsForm
          successHandler={_displayBookingForm}
          cancelHandler={_closeHandler}
          tourOperatorNotes={tourOperatorNotes}
          setTourOperatorNotes={setTourOperatorNotes}
          setFormSubmitting={setFormSubmitting}
        />
      }

      {
        (booking.step === 'book_room') &&
        <HotelBookingForm
          successHandler={setSuccess}
          cancelHandler={_closeHandler}
          tourOperatorNotes={tourOperatorNotes}
          setFormSubmitting={setFormSubmitting}
        />
      }
    </div>
  }

  return (
    <div className="booking details">
      { submitting && !success && <Loading /> }
      <div className="info scrollable">
        {
          success ?
          <BookingConfirmation
            booking   = {booking}
            departure = {moment(getDepartureDateMoment(searchedArrival, parseInt(searchedNights))).format("MM/DD/YYYY")}
            arrival   = {moment(searchedArrival).format("MM/DD/YYYY")}
            nights    = {searchedNights}
            adults    = {searchedAdults}
            user      = {user}
            />
          : _renderInfo()
        }
      </div>
    </div>
  )
}

HotelBooking.propTypes = {
  setRoomsTitle: PropTypes.func.isRequired
}

export default HotelBooking
